import React, { useState, useEffect } from 'react';
import Header from './Header/Header';
import TitleBar from './TitleBar/TitleBar';
import Aside from './Aside/Aside';
import SignUpTile from './SignUpTile/SignUpTile';
import Card from './Card/Card';
import * as S from './layout.styles'

const Layout = ({ children, title, summary, onMenuSelect,data,selectedMenu,heading }) => {
    return (
        
        <React.Fragment>
            {/* <Header /> */}
            <TitleBar heading={heading}/>
            <main>
                <Aside onMenuSelect={onMenuSelect} data={data} selectedMenu={selectedMenu} />
                <S.Content className='content'>
                    {/* <SignUpTile /> */}
                    <Card>
                        {title && <S.Title>
                            {title}
                        </S.Title>}
                        {summary && <S.Summary>
                            {summary}
                        </S.Summary>}
                        {children}
                    </Card>
                </S.Content>
            </main>
        </React.Fragment>
    );
};

export default Layout;